import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Login from "./components/Login";
import ForgotAccess from "./components/ForgotAccess";
import SignUp from "./components/SignUp";
import Dashboard from "./views/Dashboard";
import Loyalty from "./views/Loyalty";
import AddLoyalty from "./views/AddLoyalty";
import Rewards from "./views/Rewards";
import AddReward from "./views/AddReward";
import Offers from "./views/Offers";
import AddOffer from "./views/AddOffer";
import Campaigns from "./views/Campaigns";
import AddCampaign from "./views/AddCampaign";
import DietaryPreference from "./views/DietaryPreference";
import AddDietary from "./views/AddDietary";
import Users from "./views/Users";
import AddUser from "./views/AddUser";
import ROUTES from "./utils/ROUTES";
import Sample from "./views/Sample";
import Toaster from "./components/ui/Toaster";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface-page">
        <span className="text-sm text-content-label">Loading…</span>
      </div>
    );
  }

  return user ? <>{children}</> : <Navigate to={ROUTES.LOGIN} replace />;
};

const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return !user ? <>{children}</> : <Navigate to={ROUTES.DASHBOARD} replace />;
};

function App() {
  return (
    <>
    <Routes>
      {/* Public */}
      <Route path={ROUTES.LOGIN} element={<PublicRoute><Login /></PublicRoute>} />
      <Route path={ROUTES.FORGOT_ACCESS} element={<PublicRoute><ForgotAccess /></PublicRoute>} />
      <Route path={ROUTES.SIGN_UP} element={<PublicRoute><SignUp /></PublicRoute>} />
      <Route path={ROUTES.SAMPLE} element={<PublicRoute><Sample /></PublicRoute>} />

      {/* Protected */}
      <Route path={ROUTES.DASHBOARD} element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path={ROUTES.LOYALTY} element={<ProtectedRoute><Loyalty /></ProtectedRoute>} />
      <Route path={ROUTES.ADD_LOYALTY} element={<ProtectedRoute><AddLoyalty /></ProtectedRoute>} />
      <Route path={ROUTES.REWARDS} element={<ProtectedRoute><Rewards /></ProtectedRoute>} />
      <Route path={ROUTES.ADD_REWARD} element={<ProtectedRoute><AddReward /></ProtectedRoute>} />
      <Route path={ROUTES.OFFERS} element={<ProtectedRoute><Offers /></ProtectedRoute>} />
      <Route path={ROUTES.ADD_OFFER} element={<ProtectedRoute><AddOffer /></ProtectedRoute>} />
      <Route path={ROUTES.CAMPAIGNS} element={<ProtectedRoute><Campaigns /></ProtectedRoute>} />
      <Route path={ROUTES.ADD_CAMPAIGN} element={<ProtectedRoute><AddCampaign /></ProtectedRoute>} />
      <Route path={ROUTES.DIETARY} element={<ProtectedRoute><DietaryPreference /></ProtectedRoute>} />
      <Route path={ROUTES.ADD_DIETARY} element={<ProtectedRoute><AddDietary /></ProtectedRoute>} />
      <Route path={ROUTES.USERS} element={<ProtectedRoute><Users /></ProtectedRoute>} />
      <Route path={ROUTES.ADD_USER} element={<ProtectedRoute><AddUser /></ProtectedRoute>} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to={ROUTES.LOGIN} replace />} />
    </Routes>
    <Toaster />
    </>
  );
}

export default App;
